import type { AxiosInstance } from 'axios';

import { throwApiError } from 'src/api/utils';

import type { TExportData } from './export-service';

export class ExportServiceApi {
  private readonly agent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  async export(
    planVersionId: number,
    exportData: TExportData & { ganttPaletteSections?: string[] },
    planVersionName: string,
    signal: AbortSignal,
  ): Promise<File> {
    try {
      const { data } = await this.agent.get(`/export/${planVersionId}`, {
        params: {
          ...exportData,
          exportTags: exportData.exportTags.join(','),
          ganttPaletteSections: exportData.ganttPaletteSections?.join(','),
        },
        responseType: 'blob',
        signal,
      });

      const rawFile = new File([data], planVersionName, { type: 'xlsx' });

      return rawFile;
    } catch (e) {
      throwApiError(e);
    }
  }
}
